var _rect, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgInstagramBlack = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 26,
  height: 24,
  fill: "none"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 22,
  height: 20,
  x: 2,
  y: 2,
  stroke: "#000",
  strokeWidth: 2,
  rx: 6
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 13,
  cy: 12,
  r: 5,
  stroke: "#000",
  strokeWidth: 2
})), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
  cx: 19.2,
  cy: 6.8,
  r: 1.2,
  fill: "#000"
})));
export default SvgInstagramBlack;